import { Box, Container, Grid, Typography } from '@material-ui/core'
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';

function Footer() {
    return (
        <>
            <div className="mt-30 text-center">
                <Box bgcolor="#f7f6f6">
                    <Grid container justifyContent="center">
                        <Grid item xl={10} lg={10} md={10}>
                            <Grid container justifyContent="center" spacing={2}>
                                <Grid item lg={4}>
                                    <h1 className="font-bold">Optimal Conditions</h1>
                                    <CheckCircleIcon className="text-5xl text-green-600	my-3" />
                                    <p className="text-gray-800 text-xs font-semibold">The best weather conditions for a beehive inspection. Aim to inspect during these times.</p>
                                </Grid>

                                <Grid item lg={4}>
                                    <h1 className="font-bold">Okay Conditions</h1>
                                    <CheckCircleIcon className="text-5xl text-amber-600 my-3" />
                                    <p className="text-gray-800 text-xs font-semibold">Not the most optimal conditions for a beehive inspection, but can inspect if you must.</p>
                                </Grid>

                                <Grid item lg={4}>
                                    <h1 className="font-bold">Poor Conditions</h1>
                                    <CancelIcon className="text-5xl my-3 text-red-600" />
                                    <p className="text-gray-800 text-xs font-semibold">A beehive inspection is not advisable due to adverse weather conditions.</p>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Box>
            </div>

            <div className="footer">
                <Container fixed>
                <Grid container>
                    <Grid item md={12}>
                        <Typography>Copyright 2025 BeeKeepPal, Inc. All rights reserved.</Typography>
                    </Grid>
                </Grid>
            </Container>
            </div>
        </>
    )
};
export default Footer;
